import * as Yup from 'yup'

export const riscoSchema = Yup.object().shape({
  setor: Yup.object().nullable().required('Setor é obrigatório'),
  cargo: Yup.object().nullable().required('Cargo é obrigatório'),
  fatorRisco: Yup.object().nullable().required('Fator de risco é obrigatório'),
  descricao: Yup.string().required('Descrição é obrigatório'),
})
